import React, { useState } from "react";
import ModalForm from "../ModalForm";
import CustomTextInput from "../CustomTextInput";
import api from "../../api"; // Asegúrate de que esta sea la ruta correcta para tu archivo de API

export default function ClientModal({ isOpen, onClose, onClientAdded }) {
  const [name, setName] = useState("");
  const [ruc, setRUC] = useState("");
  const [legalName, setLegalName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [error, setError] = useState(null);
  const [isAdded, setIsAdded] = useState(false);

  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLogo(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setFieldErrors({});
    setError(null);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("legalName", legalName);
    formData.append("ruc", ruc);
    formData.append("email", email);
    formData.append("phone", contact);
    if (logo) {
      formData.append("logo", logo);
    }

    try {
      await api.clients.create(formData); // Aquí llamamos directamente a la API
      setIsAdded(true); // Marca como agregado
      onClientAdded(true); // Notifica al componente principal
      onClose(); // Cierra el modal al finalizar con éxito
      setName("");
      setLegalName("");
      setRUC("");
      setEmail("");
      setContact("");
      setLogo(null);
      setLogoPreview(null);
    } catch (error) {
      if (error.message) {
        setFieldErrors(error.message); // Ajustar esto según la estructura del error
      } else {
        setError("Ocurrió un error al enviar los datos.");
      }
    }
  };

  return (
    <ModalForm
      title="Agrega un nuevo cliente"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleFormSubmit}
      textBtn="Agregar cliente"
    >
      {error && <p className="text-red-600 mb-4">{error}</p>}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <CustomTextInput
            label="Nombre del cliente"
            placeholder="Ingresa el nombre del cliente"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            isRequired
          />
          {fieldErrors.name && (
            <p className="text-red-600 text-sm">{fieldErrors.name[0]}</p>
          )}
        </div>
        <div>
          <CustomTextInput
            label="Correo electrónico"
            placeholder="Ingresa el correo electrónico"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            isRequired
          />
          {fieldErrors.email && (
            <p className="text-red-600 text-sm">{fieldErrors.email[0]}</p>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <CustomTextInput
            label="Número de contacto"
            placeholder="Escribe el número de contacto"
            type="text"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            isRequired
          />
          {fieldErrors.phone && (
            <p className="text-red-600 text-sm">{fieldErrors.phone[0]}</p>
          )}
        </div>
        <div>
          <CustomTextInput
            label="RUC"
            placeholder="Escribe el RUC del cliente"
            type="text"
            value={ruc}
            onChange={(e) => setRUC(e.target.value)}
            isRequired
          />
          {fieldErrors.ruc && (
            <p className="text-red-600 text-sm">{fieldErrors.ruc[0]}</p>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <CustomTextInput
            label="Razón social"
            placeholder="Escribe la razón social"
            type="text"
            value={legalName}
            onChange={(e) => setLegalName(e.target.value)}
          />
          {fieldErrors.legalName && (
            <p className="text-red-600 text-sm">{fieldErrors.legalName[0]}</p>
          )}
        </div>
        <div>
          <label className="block text-[#8F99A6] text-xs tracking-wider">
            Logo
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
            className="mt-1 block text-sm text-gray-900 file:mr-4 file:py-2 file:px-4 file:border file:border-gray-300 file:rounded-md file:text-sm file:bg-gray-50 file:text-gray-700 hover:file:bg-gray-100"
          />
          {logoPreview && (
            <img
              src={logoPreview}
              alt="Vista previa del logo"
              className="mt-2 max-w-[150px] max-h-[150px] object-contain"
            />
          )}
        </div>
      </div>
    </ModalForm>
  );
}
